import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import ProcessSuccessful from '../../assets/icons/ProcessSuccessful';
import { getInvoice } from '../../backend-services';


  const InvoiceNotificationPage = () => {
  const navigate = useNavigate();
  const { createdInvoiceId } = useParams();
  const [searchParams] = useSearchParams();
  const createdEmail = searchParams.get('createdEmail');
  const [customerEmail, setCustomerEmail] = useState('');

 

  useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        if (createdInvoiceId) {
          const invoiceData = await getInvoice(createdInvoiceId);
          const email = invoiceData.customer.email;
          setCustomerEmail(email);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchInvoiceData();
  }, [createdInvoiceId]);
  const handleViewInvoice = () => {
    const viewInvoiceRoute = `/invoices/${createdInvoiceId}/view`;
    navigate(viewInvoiceRoute);
  };
  
  
  
  const handlePrinting = () => {
    // Add the printing logic here
    console.log('Printing...');
  };

  return (
    <>
      <div className="h-screen">
      <div className="flex items-center gap-[8.5px] ml-[em]">
            <a href="/invoices">
              <svg
                className="mt-[4px] ml-[-2em]"
                width="10"
                height="16"
                viewBox="0 0 10 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M8.5 1L1.5 8L8.5 15" stroke="#33363F" strokeWidth="2" />
              </svg>
              </a>
        <h1 className="flex items-center text-[20px] ml-[-1em] font-medium">Add New Invoice</h1>
      </div>
      <h1 className=' flex justify-center font-bold text-[40px]  mt-[2em] '>Congratulations</h1>
        <div className="flex justify-center mt-[3em] text-[16px] ">
        {customerEmail ? (
          <h3 className="mt-[-2em]">
            The invoice has also been sent to <br/>  <span className="font-bold flex justify-center">{customerEmail}</span> 
          
          </h3>
        ) : (
          <h3 className="mt-[-2em] font-bold">Invoice Created Successfully</h3>
        )}
      </div>
       
        <div className="flex justify-center mt-[1em] "> <ProcessSuccessful/></div>
        <div role="form" onSubmit={(e) => e.preventDefault()}>
          <div className="flex justify-center mt-[3em] ">
            <button
              className="w-[215px] h-[48px] rounded-md text-[#FFFFFF] text-[16px] font-medium bg-[#FF6702] "
               onClick={handleViewInvoice}
            >
              View Invoice
            </button>
          </div>
          {/* <div className="flex ml-[3em] pb-[40px]  md:ml-[15em] lg:ml-[19em]">
            <button
              className="w-[215px] h-[48px] rounded-md text-[#044E97] border border-[#044E97] text-[16px] font-medium bg-[#FFFFFF] xl:ml-[4em]"
              onClick={handlePrinting}
            >
              Print Receipt
            </button>
          </div> */}
        </div>
      </div>
    </>
  );
};

export { InvoiceNotificationPage};
